import type { AppRouter } from "@pluck/api/routers/index";
import { Link } from "@tanstack/react-router";
import type { inferRouterOutputs } from "@trpc/server";
import { Badge } from "@/components/ui/badge";
import { track } from "@/lib/analytics";
import { formatRelativeDate } from "@/lib/utils";
import { PluckThumbnail } from "./pluck-thumbnail";

export type PluckSummary =
	inferRouterOutputs<AppRouter>["plucks"]["list"]["items"][number];

export function PluckCard({ pluck }: { pluck: PluckSummary }) {
	return (
		<Link
			className="group flex flex-col overflow-hidden rounded-xl border bg-card transition-shadow hover:shadow-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
			onClick={() =>
				track("pluck.opened", { from: "library", mode: pluck.mode })
			}
			params={{ pluckId: pluck.id }}
			to="/plucks/$pluckId"
		>
			<div className="flex aspect-[4/3] items-center justify-center overflow-hidden bg-[repeating-conic-gradient(var(--color-muted)_0%_25%,transparent_0%_50%)] bg-size-[16px_16px] p-3">
				<PluckThumbnail
					alt={pluck.sourceTitle ?? pluck.sourceDomain}
					assetId={pluck.screenshotAssetId}
					className="max-h-full max-w-full rounded-sm shadow-xs"
				/>
			</div>
			<div className="flex flex-col gap-1 border-t p-3">
				<div className="flex items-center justify-between gap-2">
					<p className="truncate font-medium text-sm">{pluck.sourceDomain}</p>
					<Badge variant="secondary">{pluck.mode}</Badge>
				</div>
				<p className="truncate text-muted-foreground text-xs">
					&lt;{pluck.rootTag}&gt;
					{pluck.sourceTitle ? ` · ${pluck.sourceTitle}` : ""}
				</p>
				<p className="text-muted-foreground text-xs">
					{formatRelativeDate(pluck.createdAt)}
				</p>
			</div>
		</Link>
	);
}
